import React from 'react'

const Ratings = ({style,rating,onClick}) => {


    // const onClick=(i)=>{
    //      console.log(i)
    // }
  
  return (
    <>
      {[...Array(5)].map((_, i) => (
        <span key={i} onClick={() => onClick(i)} style={style}>
          {rating > i ? (
            <i class="bi bi-star-fill mx-2" style={{fontSize:'15px',color:"gold",cursor:'pointer'}}></i>
          ) : (
            <i class="bi bi-star mx-2" style={{fontSize:'15px',cursor:'pointer'}}></i>
          )}
        </span>
      ))}
    </>
  )
}

export default Ratings